import React from 'react';

export default function TagIcon({ width = 19, height = 18, fill = '#F7F7F7' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.25 8.25L10.5544 2.55442C10.1653 2.16527 9.9707 1.9707 9.74364 1.83156C9.54233 1.70819 9.32285 1.61729 9.09327 1.56217C8.83432 1.5 8.55916 1.5 8.00883 1.5L5 1.5M2.75 6.525L2.75 8.00589C2.75 8.37277 2.75 8.55622 2.79145 8.72885C2.82819 8.8819 2.8888 9.02822 2.97104 9.16243C3.0638 9.3138 3.19352 9.44352 3.45294 9.70294L9.30294 15.5529C9.89697 16.147 10.194 16.444 10.5365 16.5553C10.8377 16.6532 11.1623 16.6532 11.4635 16.5553C11.806 16.444 12.103 16.147 12.6971 15.5529L14.5529 13.6971C15.147 13.103 15.444 12.806 15.5553 12.4635C15.6532 12.1623 15.6532 11.8377 15.5553 11.5365C15.444 11.194 15.147 10.897 14.5529 10.3029L9.07794 4.82794C8.81852 4.56852 8.6888 4.4388 8.53743 4.34604C8.40322 4.2638 8.2569 4.20319 8.10385 4.16645C7.93122 4.125 7.74777 4.125 7.38089 4.125H5.15C4.30992 4.125 3.88988 4.125 3.56901 4.28849C3.28677 4.4323 3.0573 4.66177 2.91349 4.94401C2.75 5.26488 2.75 5.68492 2.75 6.525Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
